import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { BankDetails } from 'src/app/models/bank-details.model';
import { AuthService } from 'src/app/shared/services/auth/auth.service';
import { DisplayNotificationService } from 'src/app/shared/services/common/notification.service';
import { ReadConfigService } from 'src/app/shared/services/common/read-config.service';
import { UsersService } from 'src/app/shared/services/common/users.service';
import { PaymentsService } from 'src/app/shared/services/profile/payments.service';

@Component({
  selector: 'app-manage-banking-info',
  templateUrl: './manage-banking-info.component.html',
  styleUrls: ['./manage-banking-info.component.css']
})
export class ManageBankingInfoComponent implements OnInit {
  showAddInfoText: any;
  showForm: boolean;
  bankDetails: BankDetails;
  disableAccNumber = true;
  initData: any;
  showError: boolean;
  config: any;
  notMatchingText: any;
  routingNumberError: any;
  showRoutingError: boolean;
  addInfoText: any;
  rebankAcc: any;
  userData: any;
  isLoading: boolean;
  operators: any;
  isValidAccNo: boolean;
  invalidAccountNumber: any;
  readonly accountPattern = '^([0-9]+-)*[0-9]+$';

  constructor(
    private router: Router,
    private authService: AuthService,
    private usersService: UsersService,
    private paymentsService: PaymentsService,
    private readConfigService: ReadConfigService,
    private notificationService: DisplayNotificationService) { }

  ngOnInit() {
    this.notificationService.setUpLoading(true);
    this.operators = this.authService.getAccessOperations(2);
    this.config = this.readConfigService.getBankingInfoText();
    this.notMatchingText = this.config.NotMatching;
    this.routingNumberError = this.config.RoutingNumberError;
    this.invalidAccountNumber = this.config.InvalidAccountNumber;
    this.getEmpInfo();
  }

  getEmpInfo() {
    const inputData = { userInfo: this.usersService.UserInfo() };
    this.paymentsService.getEmpBankInfo(inputData).subscribe((data: any) => {
      if (data && data.statusCode === 200 && data.result) {
        const result = data.result;
        this.initData = JSON.stringify(result);
        this.bankDetails = new BankDetails();
        this.rebankAcc = '';
        this.bankDetails.bankName = result.bankName;
        this.bankDetails.routingNumber = result.routingNumber;
        this.bankDetails.bankAcctNumber = result.bankAcctNumber;
        this.bankDetails.bankId = result.bankId;
      } else if (data && data.statusCode === 204) {
        this.showAddInfoText = true;
        this.addInfoText = this.config.NoBankDetails;
      } else if (data && data.statusCode === 403) {
        this.router.navigate(['/forbidden']);
      } else {
        this.showAddInfoText = true;
        this.notificationService.setErrorNotification();
      }
      this.notificationService.setUpLoading(false);
    },
      (err: HttpErrorResponse) => {
        console.log(err);
        this.notificationService.setErrorNotification();
        this.notificationService.setUpLoading(false);
      });
  }

  addBankInfo() {
    this.bankDetails = new BankDetails();
    this.rebankAcc = '';
    this.resetFormFlags();
  }

  editBankInfo() {
    this.rebankAcc = null;
    this.disableAccNumber = false;
    this.resetFormFlags();
  }

  resetFormFlags() {
    this.showForm = true;
    this.showAddInfoText = false;
    this.isValidAccNo = false;
    this.showError = false;
    this.showRoutingError = false;
  }

  saveBank() {
    this.isLoading = true;
    const inputData = {
      userInfo: this.usersService.UserInfo(),
      bankId: this.bankDetails.bankId,
      accountNo: this.usersService.encrypt(this.bankDetails.bankAcctNumber, 'post'),
      userName: this.usersService.getUserName()
    };
    this.paymentsService.updateBankInfo(inputData).subscribe((data: any) => {
      if (data && data.statusCode === 201) {
        this.getEmpInfo();
        this.showForm = false;
        this.notificationService.setUpNotification({ message: this.config.SuccessMessage, success: true });
      } else {
        this.notificationService.setErrorNotification();
      }
      this.isLoading = false;
    },
      (err: HttpErrorResponse) => {
        console.log(err);
        this.isLoading = false;
        this.notificationService.setErrorNotification();
      });
  }

  cancelBank() {
    if (this.initData) {
      this.showAddInfoText = false;
      const temp = JSON.parse(this.initData);
      this.bankDetails.bankName = temp.bankName;
      this.bankDetails.routingNumber = temp.routingNumber;
      this.bankDetails.bankAcctNumber = temp.bankAcctNumber;
    } else {
      this.showAddInfoText = true;
      this.bankDetails = null;
    }
    this.showForm = false;
  }

  onValueChange() {
    this.isValidAccNo = false;
    this.showError = false;
    const accNumber = (this.bankDetails.bankAcctNumber || '').replace(/[^0-9\-\*]/g, '');
    this.bankDetails.bankAcctNumber = accNumber;
    const isValidAccNo = accNumber.match(this.accountPattern);
    if (isValidAccNo) {
      if (this.rebankAcc && this.rebankAcc !== accNumber) {
        this.showError = true;
      }
    } else {
      this.isValidAccNo = true;
    }
  }

  getBankNameFromRoutingNumber(routingNo: string) {
    const inputData = {
      routingNo,
      userInfo: this.usersService.UserInfo()
    };
    this.paymentsService.getBankName(inputData).subscribe((data: any) => {
      if (data && data.statusCode === 200 && data.result) {
        const result = data.result;
        this.bankDetails.bankName = result.bankName;
        this.bankDetails.bankId = result.id;
        this.disableAccNumber = false;
      } else if (data && data.statusCode === 204) {
        this.showRoutingError = true;
      } else if (data && data.statusCode === 403) {
        this.router.navigate(['/forbidden']);
      } else {
        this.notificationService.setErrorNotification();
      }
    },
      (err: HttpErrorResponse) => {
        console.log(err);
        this.cancelBank();
        this.notificationService.setErrorNotification();
      });
  }

  onRnValueChange(bankInfoForm: any) {
    const e = this.allowIntegers(bankInfoForm);
    if (e && e.length === 9 && e !== '000000000' && e !== '999999999') {
      this.showRoutingError = false;
      this.getBankNameFromRoutingNumber(e);
    } else {
      this.showRoutingError = true;
      this.bankDetails.bankName = null;
      this.bankDetails.bankAcctNumber = null;
      this.disableAccNumber = true;
      this.rebankAcc = null;
    }
  }

  allowIntegers(bankInfoForm: any) {
    const form = bankInfoForm.form.value;
    form.routingNumber = form.routingNumber.replace(/[^0-9]/g, '');
    bankInfoForm.reset(form);
    return form.routingNumber;
  }
}
